module.exports = __webpack_public_path__ + "img/logo.968a33d0.svg";